angular.module('skeyenoteWebApp').service('arrayOrderingSrv', ArrayOrderingService);

function ArrayOrderingService(TRASH_FOLDER_ID) {
  'ngInject';

  let arrayOrderingSrv = this;

  this.noteListOrdering = function(note) {
    if (note.id === TRASH_FOLDER_ID) {
      return '\uFFFF';
    }
    return arrayOrderingSrv.getNoteName(note);
  };

  this.getNoteName = function(note) {
    if (note.name === undefined || note.name.trim() === '') {
      return 'Note ' + note.id;
    } else {
      return note.name;
    }
  };

  this.noteComparator = function(v1, v2) {
    let note1 = v1.value || v1;
    let note2 = v2.value || v2;

    if (note1.id === TRASH_FOLDER_ID) {
      return 1;
    }

    if (note2.id === TRASH_FOLDER_ID) {
      return -1;
    }

    if (note1.children === undefined && note2.children !== undefined) {
      return 1;
    }

    if (note1.children !== undefined && note2.children === undefined) {
      return -1;
    }

    let noteName1 = arrayOrderingSrv.getNoteName(note1);
    let noteName2 = arrayOrderingSrv.getNoteName(note2);

    return noteName1.localeCompare(noteName2);
  };

  this.getNotePath = function(note) {
    if (note.path === undefined || note.path.trim() === '') {
      return 'Note ' + note.id;
    } else {
      return note.path;
    }
  };
}
